/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierAdvancedAiEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_ADVANCED_AI_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class TierAdvancedAiEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierAdvancedAiEnabledSettingParser.decode(input).map(res => new TierAdvancedAiEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return TierAdvancedAiEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierAdvancedAiEnabledSettingParser.encode(data);
    }
    static schema() {
        return TierAdvancedAiEnabledSettingParser.schema();
    }
}
